import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AccountCreationPage } from './account-creation/account-creation.page';
import { PasswordResetPage } from './password-reset/password-reset.page';
import { OktaService } from 'src/app/services/okta.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  standalone: false,
})
export class LoginPage implements OnInit {

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  });
  oktaWidgetVisible = true;

  showPassword:boolean = false;

  isLoggedIn: boolean = false;
  constructor(private fb: FormBuilder,private modalController: ModalController, private router: Router,
    private oktaService: OktaService) {
    }

  ngOnInit() {
    this.oktaWidgetVisible = true;
       this.oktaService.removeWidget();
       this.oktaService.login('#okta-signin-container');
  } 
  openMenu(){
    console.log("menu clicked")
  }
  closeLogin(){
    this.modalController.dismiss(null, 'cancel');
  }
  checkLogin(){

  }
  togglePassword() {
    this.showPassword = !this.showPassword;
  }
  async createAccount(){
    const modal = await this.modalController.create({
      component: AccountCreationPage,
      cssClass: 'configuration-modal',
      componentProps: {
        // Pass any data if needed
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();
    console.log("login pages called")
    //this.router.navigate(['/login']);
    if (role === 'confirm' && data) {
      console.log('Selected option:', data.selectedOption);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/tabs/configuration'], {
          queryParams: { configType: data.selectedOption }
        });
      });
    }
  }

  async resetPassword(){
    const modal = await this.modalController.create({
      component: PasswordResetPage,
      cssClass: 'configuration-modal',
      componentProps: {
        // Pass any data if needed
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();
    console.log("login pages called")
    //this.router.navigate(['/login']);
    if (role === 'confirm' && data) {
      console.log('Selected option:', data.selectedOption);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/tabs/configuration'], {
          queryParams: { configType: data.selectedOption }
        });
      });
    }
  }

  async checkUserAuthenticated() {
    return await this.oktaService.isUserAuthenticated();
  }

}
